/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from './http-client'

export class EuDebitMigrationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags eu-debit-migration-controller
   * @name IsOrganisationMigrated
   * @request GET:/api/v1/deutsche-bank-migration/{organisationId}/migrated
   */
  isOrganisationMigrated = (organisationId: string, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/v1/deutsche-bank-migration/${organisationId}/migrated`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static isOrganisationMigratedPath = '/v1/deutsche-bank-migration/${organisationId}/migrated'
  static isOrganisationMigratedMethod = 'GET'
}
